//=require _jquery.cookie.js

var player;
var carrousel_accueil;
var map;
var infoswindow = [];
var markers = [];

function initMap() {
	map = new google.maps.Map(document.getElementById('map'), {
		center: { lat: 43.5466733, lng: 6.9374528 },
		zoom: 16,
		maxZoom: 16
	});

	if ($('.section_map marker').length > 0) {
		$('.section_map marker').each(function() {
			var marker = $(this);
			var marker_obj = {
				id: marker.attr('id'),
				nom: marker.attr('nom'),
				adresse: marker.attr('adresse'),
				complement: marker.attr('complement'),
				codepostal: marker.attr('codepostal'),
				ville: marker.attr('ville'),
				pays: marker.attr('pays'),
				latitude: marker.attr('latitude'),
				longitude: marker.attr('longitude'),
				url: marker.attr('url')
			};
			markers.push(marker_obj);

			var adresse = marker_obj.adresse + (marker_obj.complement ? ' ' + marker_obj.complement : '') + ', ' + marker_obj.codepostal + ' ' + marker_obj.ville;

			var markerLatlng = new google.maps.LatLng(marker.attr('latitude'), marker.attr('longitude'));

			var map_marker = new google.maps.Marker({
				map: map,
				title: marker.attr('nom'),
				position: markerLatlng
			});

			var infowindow = new google.maps.InfoWindow({
				content: '<p>' + marker_obj.nom + '</p>' +
						 '<p>' + adresse + '</p>',
			});
			infoswindow.push(infowindow);

			map_marker.addListener('click', () => {
				infoswindow.forEach(function(item) {
					item.close();
				});
				infowindow.open(map, map_marker);
			});
		});
	}
}

$(document).ready(function() {
	if ($('#carrousel_accueil').length > 0) {
		carrousel_accueil = $('#carrousel_accueil');
		carrousel_accueil.owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			lazyLoad: true,
			video: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true,
			onTranslated: function(event) {
				//updateVideo();
			}
		});
	}

	triggerVideo();

	if ($('#carrousel_temoignages').length > 0) {
		$('#carrousel_temoignages').owlCarousel({
			loop: true,
			items: 1,
			margin: 0,
			dots: true,
			autoplay: true,
			autoplayTimeout: 5000,
			autoplayHoverPause: true
		});
	}

	$('#departement').on('change', function() {
		var markers_filtre = markers.filter(filterByDepartement);
		updateMap(markers_filtre);
	});
	$('#pays').on('change', function() {
		var markers_filtre = markers.filter(filterByPays);
		updateMap(markers_filtre);
	});

	// Gestion du scroll
	var lastScrollTop = $(window).scrollTop();
	var nowScrollTop = $(window).scrollTop();
	update_scroll();
	$(window).scroll(debounce(update_scroll, 16));
});

function filterByDepartement(marker) {
	var value = $('#departement').val();
	return marker.pays == 69 && marker.codepostal.substr(0, 2) == value;
}

function filterByPays(marker) {
	var value = $('#pays').val();
	return marker.pays == value;
}

function updateMap(markers) {
//console.log(markers);
	$('.cartes').hide();
	$('#map').show();
	if (markers.length > 0) {
		var bounds = new google.maps.LatLngBounds();
		markers.forEach(function(marker) {
			var markerLatlng = new google.maps.LatLng(marker.latitude, marker.longitude);
			bounds.extend(markerLatlng);
		});
		map.fitBounds(bounds);
		if (markers.length == 1) {
			map.setZoom(16);
		}
	}
}

function update_scroll() {
	//console.log('update_scroll');
	nowScrollTop = $(window).scrollTop();
	/*if (nowScrollTop > lastScrollTop) {
		console.log('scroll down');
	} else if (nowScrollTop < lastScrollTop) {
		console.log('scroll up');
	} else {
		console.log('no scroll');
	}*/

	update_logo_size();

	lastScrollTop = nowScrollTop;
}

function update_logo_size() {
	if (nowScrollTop > 100) {
		$('.header .logo').addClass('resize');
	} else if (nowScrollTop > 0 && nowScrollTop < 100) {
		if (nowScrollTop > lastScrollTop) {
			$('.header .logo').addClass('resize');
		} else {
			$('.header .logo').removeClass('resize');
		}
	} else {
		$('.header .logo').removeClass('resize');
	}
}

function triggerVideo() {
	if ($.cookie('home_video') === undefined) {
		setTimeout(function() {
			$('#trigger_video').click();
		}, 4000);
		$.cookie('home_video', 'true', { expires: 1 });
	}
}

function updateVideo() {
	if ($('#carrousel_accueil .owl-item.active').data('video') !== undefined) {
		carrousel_accueil.trigger('stop.owl.autoplay');
		if ($('#carrousel_accueil .owl-item.active iframe').length > 0) {
			$('#carrousel_accueil .owl-item.active').find('.owl-video-play-icon').remove();
		} else {
			$('#carrousel_accueil .owl-item.active').find('.owl-video-play-icon').trigger('click');

			var iframe = $('#carrousel_accueil .owl-item.owl-video-playing iframe');
			iframe.attr('id', 'iframe_player');
			iframe.attr('src', iframe.attr('src') + '&enablejsapi=1');
			player = new YT.Player('iframe_player', {
				playerVars: { 'autoplay': 1, 'controls': 0, 'showinfo': 0 },
				events: {
					'onReady': onPlayerReady,
					'onStateChange': onPlayerStateChange
				}
			});
		}
	}
}

function onYouTubeIframeAPIReady() {
	//updateVideo();
}

function onPlayerReady(event) {
	event.target.setVolume(0);
	event.target.playVideo();
}

function onPlayerStateChange(event) {
	switch (event.data) {
		case YT.PlayerState.ENDED:
			player.destroy();
			carrousel_accueil.trigger('next.owl.carousel');
			carrousel_accueil.trigger('play.owl.autoplay');
			break;
	}
}
